export default __webpack_public_path__ + "static/media/copyright.899823b3.png";